// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3brv9","col":"CardReaderDesc_col__2f7lt","label":"CardReaderDesc_label__XTwUD"};